export default __webpack_public_path__ + "img/01e860da034bed3830e04c9f9d136e9c.png";